<div class="flyout-action-list-component">
  <div class="flyout-data-group">
    <mat-expansion-panel [expanded]="!expandedTab || expandedTab === 'action-list'" class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <img class="header-icon" src="/assets/img/icons_fl/clicks.svg" width="32px" height="32px" />
        <span>{{ "flyout.actionList.title" | translate }}</span>
      </mat-expansion-panel-header>

      @for (action of sessionActions; track action) {
        <div class="expansion-panel-row values">
          <div class="column time">
            @if (
              action.type === SessionActionTypes.Pageview ||
              action.type === SessionActionTypes.Click ||
              action.type === SessionActionTypes.Outbound ||
              action.type === SessionActionTypes.WidgetOpen ||
              action.type === SessionActionTypes.WidgetClickthrough ||
              action.type === SessionActionTypes.WidgetConversion ||
              action.type === SessionActionTypes.Goal ||
              action.type === SessionActionTypes.Purchase
            ) {
              <span>
                {{ action.formattedTime }}
              </span>
            }
          </div>
          <div class="column duration">
            @if (action.duration) {
              <div class="duration-indicator" [style.width.%]="action.duration >= 90 ? 100 : (action.duration / 90) * 100"></div>
            }
            <!--<div class="duration-text">{{action.actionType}}</div>-->
            @if (action.duration) {
              <div class="duration-text">{{ action.duration | prettySeconds }}</div>
            }
          </div>
          @if (action.type === SessionActionTypes.Pageview) {
            <div class="column content">
              <div class="content-row title" [innerHTML]="action.title" [matTooltip]="action.title | removeHtml" [matTooltipDisabled]="isMobile"></div>
              <div class="content-row url" [matTooltip]="action.url | removeHtml" [matTooltipDisabled]="isMobile">
                <a href="{{ action.fullUrl }}" target="_blank" rel="noopener noreferrer">{{ action.url }}</a>
              </div>
            </div>
          }
          @if (action.type === SessionActionTypes.Click) {
            <div class="column content">
              <div class="content-row url">
                <a href="{{ action.fullUrl }}" [matTooltip]="action.url | removeHtml" [matTooltipDisabled]="isMobile" target="_blank" rel="noopener noreferrer">
                  {{ action.url }}
                </a>
              </div>
            </div>
          }
          @if (action.type === SessionActionTypes.WidgetOpen) {
            <div class="column content">
              <div class="content-row text" [matTooltip]="action.title | removeHtml" [matTooltipDisabled]="isMobile">
                <mat-icon>visibility</mat-icon>
                <span [innerHTML]="action.title"></span>
              </div>
            </div>
          }
          @if (action.type === SessionActionTypes.WidgetClickthrough) {
            <div class="column content">
              <div class="content-row text" [matTooltip]="action.title | removeHtml" [matTooltipDisabled]="isMobile">
                <mat-icon>mouse</mat-icon>
                <span [innerHTML]="action.title"></span>
              </div>
            </div>
          }
          @if (action.type === SessionActionTypes.WidgetConversion) {
            <div class="column content">
              <div class="content-row text" [matTooltip]="action.title | removeHtml" [matTooltipDisabled]="isMobile">
                <mat-icon>stars</mat-icon>
                <span [innerHTML]="action.title"></span>
              </div>
            </div>
          }
          @if (action.type === SessionActionTypes.Scroll) {
            <div class="column content">
              <div class="content-row text" [matTooltip]="action.title | removeHtml" [matTooltipDisabled]="isMobile">
                @if (action.scrollDown) {
                  <mat-icon>arrow_downward</mat-icon>
                }
                @if (!action.scrollDown) {
                  <mat-icon>arrow_upward</mat-icon>
                }
                <span [innerHTML]="action.title"></span>
              </div>
            </div>
          }
          @if (action.type === SessionActionTypes.Goal || action.type === SessionActionTypes.Purchase) {
            <div class="column content">
              <div class="content-row text" [matTooltip]="action.title | removeHtml" [matTooltipDisabled]="isMobile">
                <div class="icon">
                  @if (action.title !== "gave consent") {
                    <img src="/assets/img/medal.svg" />
                  }
                  @if (action.title === "gave consent") {
                    <mat-icon class="consent">verified_user</mat-icon>
                  }
                </div>
                <div [innerHTML]="action.title"></div>
              </div>
            </div>
          }
          @if (action.type === SessionActionTypes.Outbound) {
            <div class="column content">
              <div class="content-row title" [innerHTML]="action.title" [matTooltip]="action.title | removeHtml" [matTooltipDisabled]="isMobile"></div>
              <div class="content-row url" [matTooltip]="action.url | removeHtml" [matTooltipDisabled]="isMobile">
                <a href="{{ action.url }}" target="_blank" rel="noopener noreferrer">{{ action.url }}</a>
              </div>
            </div>
          }
          @if (action.type === SessionActionTypes.Event) {
            <div class="column content">
              <div class="content-row text" [matTooltip]="action.title | removeHtml" [matTooltipDisabled]="isMobile">
                <mat-icon>bolt</mat-icon>
                <div [innerHTML]="action.title"></div>
              </div>
            </div>
          }
          @if (action.type === SessionActionTypes.PartialSubmitSurvey) {
            <div class="column content">
              <div class="content-row text" [matTooltip]="action.title | removeHtml" [matTooltipDisabled]="isMobile">
                <mat-icon>bolt</mat-icon>
                <div [innerHTML]="action.title"></div>
              </div>
            </div>
          }
          @if (action.type === SessionActionTypes.PartialSubmit) {
            <div class="column content">
              <div class="content-row text" [matTooltip]="action.title | removeHtml" [matTooltipDisabled]="isMobile">
                <mat-icon>bolt</mat-icon>
                <div [innerHTML]="action.title"></div>
              </div>
            </div>
          }
        </div>
      }
    </mat-expansion-panel>
  </div>
</div>
